import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from './api';

const ALL_KEY = ['notifications'] as const;

export const notificationKeys = {
  all: ALL_KEY,
  list: (page: number) => [...ALL_KEY, 'list', page] as const,
  unreadCount: [...ALL_KEY, 'unread-count'] as const,
};

export function useNotifications(page = 1, limit = 5) {
  return useQuery({
    queryKey: [...notificationKeys.list(page), limit],
    queryFn: () => notificationsApi.getAll(page, limit),
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unreadCount,
    queryFn: notificationsApi.getUnreadCount,
    refetchInterval: 30_000,
  });
}

export function useMarkAsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: notificationsApi.markAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}

export function useMarkAllAsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: notificationsApi.markAllAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}
